export const ROI_REVENUE_SOURCES = [
  'admob',
  'waterfall_admob',
  'facebook',
  'pangle',
  'applovin',
  'applovin_admob',
  'unity',
  'vungle',
  'mintegral',
  'apple',
  'ironsource',
  'fyber',
  'moloco',
  // 'moloco_admob',
  'google_play_subscription',
  'other',
]
